import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

/**
 * Side-варіанти панелі. Mobile-first: `bottom` (дефолт) — повноширинний лист,
 * заокруглений зверху, прилип до низу; `right` — slide-over для ширших екранів.
 * Рух (slide/fade) реалізований keyframes-ами у SheetContent/SheetOverlay.
 */
export const sheetVariants = cva(
  // `overflow-y-auto` + `overscroll-contain`: висота обмежена (`max-h`/`h-full`),
  // тож контент, що переростає панель, має скролитися всередині, а не кліпитися.
  "bg-popover text-popover-foreground fixed z-50 flex flex-col gap-4 overflow-y-auto overscroll-contain shadow-lg outline-none",
  {
    variants: {
      side: {
        bottom:
          "inset-x-0 bottom-0 max-h-[85dvh] rounded-t-xl border-t px-6 pt-3 pb-[max(1.5rem,env(safe-area-inset-bottom))]",
        right:
          "inset-y-0 right-0 h-full w-3/4 max-w-sm border-l p-6 sm:max-w-sm",
      },
    },
    defaultVariants: {
      side: "bottom",
    },
  },
)

export type SheetVariants = VariantProps<typeof sheetVariants>
export type SheetSide = NonNullable<SheetVariants["side"]>
